import classNames from 'classnames';
import { FC } from 'react';
import { ShopItemType } from 'react-easyrocket';
import { useLocation } from 'react-router';
import coin from 'src/assets/images/shop/shopCoin.webp';
import { useLocalCurrency } from 'src/hooks/useLocalCurrency';

interface BuyMoneyProps {
  customCoinImg?: string;
  item?: ShopItemType;
}

export const BuyMoney: FC<BuyMoneyProps> = ({ item, customCoinImg = coin }) => {
  const { currencyIcon, currencyName } = useLocalCurrency();
  const { pathname } = useLocation();

  const isAccount = pathname.includes('account');

  return (
    <div
      className={classNames(
        'px-[22px] flex items-center justify-between gap-5 flex-col text-sp_card_text font-bold',
        isAccount ? 'pb-10 pt-0' : 'pb-10 pt-2.5'
      )}>
      <div
        className={classNames(
          'flex items-center gap-2 text-sp_card_amount font-bold',
          isAccount ? 'text-[40px] pt-3' : 'text-[55px] leading-[55px]'
        )}
        style={{ filter: `${!isAccount && 'drop-shadow( 2px 2px 0px var(--sp_card_shadow))'}` }}>
        <span>{item?.amount ? item?.amount?.[currencyName] / 100 : 0}</span>
        <span>{currencyIcon}</span>
      </div>
      <div className="rounded-[40px] px-[15px] my-[5px] gap-2.5 py-[5px] flex items-center justify-center text-3xl bg-sp_card_coins_bg">
        <span>{item?.costPoints || 0}</span>
        <img src={customCoinImg} alt="coin" className="w-10" />
      </div>
    </div>
  );
};
